<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
    // layout: () => import("./components/layout/index"),
  },
  data() {
    return {
      path: ''
    }
  },
  mounted() {
    this.path = this.$route.path
  },
  watch: {
    $route(to) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.path = to.path
    },
  },
};
</script>

<style>
@import "common/css/common.scss";

body{
  min-width: 1400px;
}
</style>
